import { jsx as _jsx } from "react/jsx-runtime";
import { useI18nProvider, useUpsellProvider } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../store/stores.js";
import { __, _i, _n, _x } from "../../utils/i18n.js";
import { Provider } from "../provider.js";
const RootStoreListener = ({ children })=>{
    const { optionStore: { others: { isPro, isLicensed, hints, proUrl, isDemoEnv }, fomoCoupon } } = useStores();
    const [I18nContextProvider, i18nContextValue] = useI18nProvider({
        __,
        _i,
        _n,
        _x
    });
    const [UpsellContextProvider, upsellContextValue] = useUpsellProvider({
        isPro,
        isLicensed,
        isDemoEnv,
        hint: hints?.proDialog,
        proUrl,
        fomoCoupon
    }, {}, {
        inherit: [
            "isLicensed",
            "fomoCoupon"
        ]
    });
    return /*#__PURE__*/ _jsx(I18nContextProvider, {
        value: i18nContextValue,
        children: /*#__PURE__*/ _jsx(UpsellContextProvider, {
            value: upsellContextValue,
            children: children
        })
    });
};
/**
 * Provide multiple contexts so e.g. `@devowl-wp/react-cookie-banner-admin` can be used in customizer.
 */ const CustomizeContextProvider = ({ children })=>{
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(RootStoreListener, {
            children: children
        })
    });
};
export { CustomizeContextProvider };
